import React, { ChangeEvent, FC, Key, ReactElement } from 'react'
import { InputAdornment, TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { AutocompleteRenderInputParams } from '@material-ui/lab'

export interface SelectFilterOption {
    label: string
    value: string | number
}

interface SelectFilterProps {
    options: SelectFilterOption[]
    label: string
    icon: ReactElement
    onChange: (value: Nullable<SelectFilterOption>) => void
    disabled?: boolean
    allowClearable?: boolean
    value?: Nullable<SelectFilterOption>
    defaultValue?: Key
}

export const SelectFilter: FC<SelectFilterProps> = ({
    options,
    label,
    icon,
    onChange,
    disabled,
    allowClearable,
    value,
    defaultValue
}: SelectFilterProps): ReactElement => (
    <Autocomplete
        onChange={(_: ChangeEvent<object>, val: Nullable<SelectFilterOption>): void => onChange(val)}
        options={options}
        classes={{ popper: 'select-filter-popper' }}
        getOptionLabel={(option: SelectFilterOption): string => option.label}
        value={value ?? options?.find((opt: SelectFilterOption): boolean => opt.value === defaultValue) ?? null}
        disableClearable={!allowClearable}
        disabled={disabled}
        renderInput={(params: AutocompleteRenderInputParams): ReactElement => (
            <TextField
                {...params}
                size='small'
                label={label}
                variant='outlined'
                InputProps={{
                    ...params.InputProps,
                    startAdornment: <InputAdornment position='start'>{icon}</InputAdornment>
                }}
            />
        )}
    />
)
